import { IAbsenceGroupsOrderConfiguration } from "src/Pages/Company/Absences/AbsenceGroups/AbsenceGroups.models";
import { IAbsenceGroupTreeNode } from "./transformGroupedAbsenceTypesToTreeItems";

export const GROUP_ID_PREFIX = "group-";

export const applyOrderToItems = (
  items: IAbsenceGroupTreeNode[],
  order: IAbsenceGroupsOrderConfiguration
): IAbsenceGroupTreeNode[] => {
  const orderMap = new Map(
    order.absenceGroups.map((g, gi) => [
      g.absenceGroupId,
      { groupIndex: gi, group: g },
    ])
  );

  const sorted = [...items].sort((a, b) => {
    const aIdx =
      orderMap.get(a.id.replace(GROUP_ID_PREFIX, ""))?.groupIndex ?? Infinity;
    const bIdx =
      orderMap.get(b.id.replace(GROUP_ID_PREFIX, ""))?.groupIndex ?? Infinity;
    return aIdx - bIdx;
  });

  return sorted.map((groupNode) => {
    const groupId = groupNode.id.replace(GROUP_ID_PREFIX, "");
    const groupOrder = orderMap.get(groupId);
    if (!groupOrder || !groupNode.children) return groupNode;

    const typeOrderMap = new Map(
      groupOrder.group.absenceTypes.map((t, ti) => [
        t.absenceTypeId,
        { typeIndex: ti, type: t },
      ])
    );

    const sortedChildren = [...groupNode.children].sort((a, b) => {
      const aIdx = typeOrderMap.get(a.id)?.typeIndex ?? Infinity;
      const bIdx = typeOrderMap.get(b.id)?.typeIndex ?? Infinity;
      return aIdx - bIdx;
    });

    return {
      ...groupNode,
      children: sortedChildren.map((parentNode) => {
        const typeOrder = typeOrderMap.get(parentNode.id);
        if (!typeOrder || !parentNode.children) return parentNode;

        const childOrderIds = typeOrder.type.childAbsenceTypes;
        const sortedGrandchildren = [...parentNode.children].sort((a, b) => {
          const aIdx = childOrderIds.indexOf(a.id);
          const bIdx = childOrderIds.indexOf(b.id);
          return (
            (aIdx === -1 ? Infinity : aIdx) - (bIdx === -1 ? Infinity : bIdx)
          );
        });

        return { ...parentNode, children: sortedGrandchildren };
      }),
    };
  });
};

export const treeToOrderPayload = (
  items: IAbsenceGroupTreeNode[]
): IAbsenceGroupsOrderConfiguration => ({
  absenceGroups: items.map((groupNode) => ({
    absenceGroupId: groupNode.id.replace(GROUP_ID_PREFIX, ""),
    absenceTypes: (groupNode.children ?? []).map((parentNode) => ({
      absenceTypeId: parentNode.id,
      childAbsenceTypes: (parentNode.children ?? []).map((c) => c.id),
    })),
  })),
});
